import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { lighten } from 'polished';
import styled, { css } from 'styled-components';
const Button = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  padding: 16px;
  background-color: ${brand.grey.grey89};
  color: ${brand.grey.grey20};
  border-radius: 30px;
  ${fonts.DaxPro.Bold};
  font-size: 14px;

  @media ${from(Device.Tablet)} {
    padding: 18px;
    font-size: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 20px;
    font-size: 18px;
  }

  &:hover {
    background-color: ${lighten(-0.05, brand.grey.grey89)};
    color: ${brand.grey.grey20};
  }

  &:active {
    background-color: ${lighten(-0.1, brand.grey.grey89)};
    color: ${brand.grey.grey20};
  }

  ${({ isActive }) => isActive
    ? css `
          background-color: ${brand.primary.dark};
          color: ${brand.white};

          &:hover {
            background-color: ${lighten(-0.05, brand.primary.dark)};
            color: ${brand.white};
          }

          &:active {
            background-color: ${lighten(-0.1, brand.primary.dark)};
            color: ${brand.white};
          }
        `
    : null}
`;
const TabButtonStyles = {
    Button,
};
export default TabButtonStyles;
